import { render, staticRenderFns } from "./SwiperTour.vue?vue&type=template&id=3d0c894f&"
import script from "./SwiperTour.vue?vue&type=script&lang=js&"
export * from "./SwiperTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports